import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for D502 (Receipt Approval)
// ============================================================

export interface PendingItem {
  fd120_01: string;        // 繳庫單號
  fd120_11: string | null; // 繳庫日期 (ISO string)
  fd120_12: string;        // 供應商代碼
  supplier_name: string;   // 供應商名稱
  fd120_21: string;        // 採購單號
  fd120_14: string;        // 庫位
  fd120_17: string;        // 部門代碼
  dept_name: string;       // 部門名稱
  can_approve: boolean;    // 是否可核准
}

export interface QueryResponse {
  items: PendingItem[];
  total: number;
}

export interface ApproveResultItem {
  receipt_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const d502Api = {
  /** Query pending receipt items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d502/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch approval for selected receipt items */
  async execute(receiptNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/d502/execute', {
      receipt_nos: receiptNos,
    });
    return res.data;
  },
};
